export const INC_DISHES = "include_dishes";
export const INC_CATEGORIES = "include_categories";
export const EXC_DISHES = "exclude_dishes";
export const EXC_CATEGORIES = "exclude_categories";

export const extraCalorieIntakeQuestionsTitle = {
  extra_calorie_tea_coffee:
    "What is your extra calorie intake from tea/coffee?",
  extra_calorie_protein_supplement:
    "What is your extra calorie intake from protein?",
  extra_calorie_dessert_nightbinge:
    "What is your extra calorie intake from dessert/night-binge?",
  extra_calorie_others: "What is your extra calorie intake from others?",
};

export const defaultFormState = {
  age: {},
  weight: {},
  height: {},
  gender: {},
  how_often_nutrition: {},
  how_many_meals: {},
  cuisine_types: {},
  veg_region_cuisine: {},
  nonveg_region_cuisine: {},
  egg_region_cuisine: {},
  poultry_frequency: {},
  which_staples: {},
  conditions_nutrition: {},
  fasting_days: {},
  no_nonveg_days: {},
  no_egg_days: {},
  include_dishes: {},
  include_categories: {},
  exclude_dishes: {},
  exclude_categories: {},
  mealplan_type_lunch: {},
  mealplan_type_dinner: {},
  extra_calorie_tea_coffee: {},
  extra_calorie_protein_supplement: {},
  extra_calorie_dessert_nightbinge: {},
  extra_calorie_others: {},
  pre_workout_slot: {},
  pre_workout_snacks: {},
  low_carb_meal: {},
  gut_issues: {},
  gut_food_triggers: {},
  water_intake: {},
  selected_state: {},
  selected_global: {},
  secondary_region: {},
  tertiary_region: {},
  items_to_avoid: {},
  items_to_avoid_for_veg: {},
  items_to_avoid_for_non_veg: {},
  workout_type: {},
  workout_intensity: {},
  workout_duration: {},
  use_regional_staple: {},
  regional_staple_preference: {},
  staple_preference_lunch: {},
  staple_preference_dinner: {},
};

export const inputTypeText: { [key: string]: any } = {
  age: true,
  height: true,
  weight: true,
  extra_calorie_others: true,
  water_intake: true,
};

export const inputTypeSingleSelect: { [key: string]: any } = {
  gender: true,
  how_often_nutrition: true,
  cuisine_types: true,
  // veg_region_cuisine: true,
  // egg_region_cuisine: true,
  // nonveg_region_cuisine: true,
  poultry_frequency: true,
  mealplan_type_lunch: true,
  mealplan_type_dinner: true,
  extra_calorie_tea_coffee: true,
  extra_calorie_protein_supplement: true,
  extra_calorie_dessert_nightbinge: true,
  pre_workout_slot: true,
  pre_workout_snacks: true,
  low_carb_meal: true,
  gut_issues: true,
  gut_food_triggers: true,
  selected_state: true,
  selected_global: true,
  secondary_region: true,
  tertiary_region: true,
  workout_intensity: true,
  workout_duration: true,
  use_regional_staple: true,
};

export const defaultOptionsStatic: any = {
  gender_options: [
    {
      value: "male",
      label: "Male",
    },
    {
      value: "female",
      label: "Female",
    },
  ],
  how_often_nutrition_options: [],
  how_many_meals_options: [],
  cuisine_types_options: [],
  veg_region_cuisine_options: [],
  egg_region_cuisine_options: [],
  nonveg_region_cuisine_options: [],
  poultry_frequency_options: [],
  which_staples_options: [],
  conditions_nutrition_options: [],
  fasting_days_options: [],
  no_nonveg_days_options: [],
  no_egg_days_options: {},
  mealplan_type_lunch_options: [],
  mealplan_type_dinner_options: [],
  extra_calorie_tea_coffee_options: [
    {
      value: "0",
      label: "Select an option",
    },
    {
      value: "120",
      label: "1-2 cups in a day (kcal 120)",
    },
    {
      value: "240",
      label: "3-4 cups in a day (kcal 240)",
    },
  ],
  extra_calorie_protein_supplement_options: [
    {
      value: "0",
      label: "Select an option",
    },
    {
      value: "150",
      label: "1 scoop - 150 kcals",
    },
    {
      value: "300",
      label: "2 scoops - 300 kcals",
    },
  ],
  extra_calorie_dessert_nightbinge_options: [
    {
      value: "0",
      label: "Select an option",
    },
    {
      value: "100",
      label: "Small portion - 100 kcals",
    },
    {
      value: "200",
      label: "Medium - 200 kcals",
    },
    {
      value: "300",
      label: "High - 300 kcals",
    },
  ],
  pre_workout_slot_options: [],
  pre_workout_snacks_options: [],
  low_carb_meal_options: [
    {
      value: "lunch",
      label: "Lunch",
    },
    {
      value: "dinner",
      label: "Dinner",
    },
  ],
  gut_issues_options: [],
  gut_food_triggers_options: [],
  states_east_options: [],
  states_west_options: [],
  states_north_options: [],
  states_south_options: [],
  global_region_options: [],
  items_to_avoid_options: [],
  items_to_avoid_for_veg_options: [],
  items_to_avoid_for_non_veg_options: [],
  workout_type_options: [],
  workout_intensity_options: [],
  workout_duration_options: [],
  use_regional_staple_options: [],
};
